import React, { PureComponent, Fragment } from 'react'
import { map, replace } from 'lodash-es'
import { getParams } from '../../utilities/route'
import { generatePath } from 'react-router'
import styled from 'styled-components'
import { Dropdown } from 'react-bootstrap'
import { TABLET, LAPTOP } from '../../utilities/breakpoints'

class LanguageSelector extends PureComponent {

  renderLanguage = (code) => {
    const { location: { pathname }, match: { url, path } } = this.props
    const {
      languageCode,
      surveyId,
      page,
      catalystId,
      discussionId,
      commentId,
      topicId
    } = getParams(this.props)

    const to = replace(
      pathname,
      url,
      generatePath(path, {
        languageCode: code,
        surveyId,
        catalystId,
        page,
        discussionId,
        commentId,
        questions: 'questions',
        topicId
      })
    )

    const handleLanguageChange = () => {
      this.props.history.push(to);
    }

    return (
      <Fragment key={code}>
        <Dropdown.Item onClick={() => handleLanguageChange()} className={languageCode === code ? 'active' : ''}>
          {code.toUpperCase()}
        </Dropdown.Item>
      </Fragment>
    )
  }

  render () {
    const {
      surveyLanguages,
      children,
      match: {
        params: {
          languageCode
        }
      }
    } = this.props

    return (
      <NavLanguage className={surveyLanguages.length < 2 ? "nav-language single-language" : "nav-language"}>
        {children}
        {surveyLanguages.length > 1 &&
          <Dropdown className="dropdown-language">
            <Dropdown.Toggle id="toggle-dropdown-language">
              {languageCode}
              <span className="ant-select-arrow"/>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              {map(surveyLanguages, (code) => this.renderLanguage(code))}
            </Dropdown.Menu>
          </Dropdown>
        }
      </NavLanguage>
    )
  }
}

export default LanguageSelector

const NavLanguage = styled.ul`
  display: flex;
  align-items: center;
  border-radius: 10px;
  padding: 10px 0;
  margin: 0;
  
  .nav-aftergame & {
    padding: 0;
    background-color: transparent;
  }
  
  .dropdown-language {
    #toggle-dropdown-language {
      background-color: transparent;
      color: #23233f;
      border: none;
      padding: 10px 20px 10px 10px;
      text-transform: uppercase;
      outline: none;
      
      &:after {
        display: none;
      }
      
      .ant-select-arrow {
        font-size: 17px;
        color: #23233F;
        right: -2px;
        margin-top: -8px;
      }
      
      .ant-select-arrow:before {
        transition: transform 0.2s ease;
      }
      
      &:hover {
        color: #f58220;
      }
      
      &:focus, &:active {
        outline: none;
        border: none;
        box-shadow: none;
      }
    } 
    
    &.show #toggle-dropdown-language .ant-select-arrow:before {
       transform: rotate(180deg);
    }
    
    .dropdown-menu {
      min-width: 50px;
      border: none;
      box-shadow: 0 1px 6px rgba(0,0,0,0.2);
      
      .dropdown-item {
        padding: 0.25rem 1.25rem;
        
        &:hover {
          background-color: transparent;
          color: #f58220; 
        }
        
        &.active {
          background-color: transparent;
          color: #f58220;
        }
      }
    }
  }
  
  @media${TABLET} {
    .dropdown-language {
      .dropdown-menu {
        margin-left: -10px !important;
      }
    }
  }
  
  @media${LAPTOP} {
    .nav-aftergame & {
      //height: 60px;
      padding: 0;
      
      &.single-language {
        //padding: 0 15px 0 0;
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/ui/language-selector.js